/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActiveMenuItem
 */
export interface ActiveMenuItem {
    /**
     * 
     * @type {string}
     * @memberof ActiveMenuItem
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ActiveMenuItem
     */
    subMenuPath: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ActiveMenuItem
     */
    shortText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActiveMenuItem
     */
    icon?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ActiveMenuItem
     */
    productId?: number | null;
}

export function ActiveMenuItemFromJSON(json: any): ActiveMenuItem {
    return ActiveMenuItemFromJSONTyped(json, false);
}

export function ActiveMenuItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveMenuItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'subMenuPath': json['subMenuPath'],
        'shortText': !exists(json, 'shortText') ? undefined : json['shortText'],
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
        'productId': !exists(json, 'productId') ? undefined : json['productId'],
    };
}

export function ActiveMenuItemToJSON(value?: ActiveMenuItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'subMenuPath': value.subMenuPath,
        'shortText': value.shortText,
        'icon': value.icon,
        'productId': value.productId,
    };
}


